import { NativeStackScreenProps } from "@react-navigation/native-stack"
import { RootStackParamList } from "../../navigation/types"
import { ROUTE } from "../../navigation/routes"

type Props = NativeStackScreenProps<RootStackParamList, ROUTE.PAYMENT_PRODUCT>

export function PaymentProductScreen({ route, navigation }: Props) {
  return <></>
}
